import { ConfigurationType, ConfigurationState } from './Configuration.js';

class ConfigurationMapper {
  static getAllConfigurationsModelFromResponse(data) {
    return Object.keys(data).map(identifier => {
      const {
        integration,
        ecommerce_integration_type,
        configuration,
        state
      } = data[identifier];
      return {
        identifier,
        integration,
        type: ConfigurationType[ecommerce_integration_type],
        data: configuration,
        state: ConfigurationState[state]
      };
    });
  }
  static createPayload(_ref) {
    let {
      integration,
      type,
      data
    } = _ref;
    return {
      integration,
      ecommerce_integration_type: type,
      configuration: data
    };
  }
  static updatePayload(_ref2) {
    let {
      identifier,
      integration,
      type,
      data,
      state
    } = _ref2;
    return {
      identifier,
      integration,
      ecommerce_integration_type: type,
      configuration: data,
      state
    };
  }
}

export { ConfigurationMapper };
//# sourceMappingURL=ConfigurationMapper.js.map
